/**
 * Simple visual workflow for non-technical CRM operators (no Mermaid required).
 */

import React from 'react'
import { CRM_STATUS_PIPELINE, getStatusLabel } from '../../../content/crm-help'

export default function CrmFlowDiagram({ title, subtitle, steps = [], note }) {
  if (!steps.length) return null

  return (
    <figure className="rounded-lg border border-gray-200 bg-gradient-to-b from-gray-50 to-white p-4 sm:p-5">
      <figcaption className="mb-4">
        <h4 className="text-base font-semibold text-gray-900">{title}</h4>
        {subtitle && <p className="mt-1 text-sm text-gray-600">{subtitle}</p>}
      </figcaption>

      <ol className="space-y-0">
        {steps.map((step, index) => (
          <li key={index} className="flex gap-3">
            <div className="flex flex-col items-center shrink-0">
              <span
                className="flex size-8 items-center justify-center rounded-full bg-primary-darkGreen text-sm font-semibold text-white"
                aria-hidden
              >
                {index + 1}
              </span>
              {index < steps.length - 1 && (
                <span className="w-0.5 flex-1 min-h-[1.25rem] bg-gray-300 my-1" aria-hidden />
              )}
            </div>
            <div className={`pb-4 min-w-0 ${index === steps.length - 1 ? 'pb-0' : ''}`}>
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed pt-1">{step}</p>
            </div>
          </li>
        ))}
      </ol>

      {note && (
        <p className="mt-4 pt-4 border-t border-gray-200 text-sm text-gray-600 leading-relaxed">
          <span className="font-medium text-gray-800">Tip: </span>
          {note}
        </p>
      )}
    </figure>
  )
}

export function CrmStatusPipeline() {
  const pipeline = CRM_STATUS_PIPELINE

  return (
    <div
      className="rounded-lg border border-gray-200 bg-white p-4"
      role="img"
      aria-label="Main case status order from new to in Simple Practice"
    >
      <div className="flex flex-wrap items-center gap-x-2 gap-y-2">
        {pipeline.map((status, index) => (
          <React.Fragment key={status}>
            <span className="inline-flex items-center rounded-md bg-green-50 border border-green-200 px-3 py-1.5 text-sm font-medium text-green-900">
              {getStatusLabel(status)}
            </span>
            {index < pipeline.length - 1 && (
              <span className="text-gray-400 text-lg font-light" aria-hidden>
                →
              </span>
            )}
          </React.Fragment>
        ))}
      </div>
      <p className="mt-3 text-sm text-gray-600">
        Side paths from most active stages: On hold, Lost, Not interested. Ask a Hub admin if you
        need to fix a status that is locked.
      </p>
    </div>
  )
}
